<template>
  <div class="name">
    {{ getName }} <span class="pronouns" v-if="getPronouns">({{ getPronouns }})</span>
  </div>
</template>

<script>
export default {
  name: 'Name',
  props: {
    data: Object,
    name: String,
    pronouns: String
  },
  computed: {
    getName() {
        if (this.name) return this.name
        return this.data.title
    },
    getPronouns() {
      if (this.pronouns && this.pronouns != '') return this.pronouns
      if (!this.data.data) return;
      const pronouns = this.isSent ? this.data.data.recipientPronouns : this.data.data.senderPronouns;

      if (pronouns && pronouns !== '') {
        return pronouns;
      }
      return ''
    },
    isSent() {
      return this.data.sentOrReceived == "sent"
    }
  }
};
</script>

<style scoped lang="scss">
.name {
  font-size: 16px;
}
.pronouns {
  color: $grey-2;
  font-weight: normal;
  font-size: 13px;
}
</style>
